module.exports = __webpack_public_path__ + "img/faxian.eeba603d.svg";